import request from '@/utils/request'
import { appCode } from '@/utils/dictionaries'

/**
 * AI安全帽告警记录告警数据
 * @param {object} parameter
 */
export function getListISUPRecord (parameter) {
  return request({
    url: `iot/WarningData/listISUPRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * AI火焰监测告警数据
 * @param {object} parameter
 */
export function getlistAIFire (parameter) {
  return request({
    url: `iot/WarningData/listAIFire`,
    method: 'get',
    params: parameter
  })
}

/**
 * AI禁区闯入监测告警数据
 * @param {object} parameter
 */
export function getListAIRestricted (parameter) {
  return request({
    url: `iot/WarningData/listAIRestricted`,
    method: 'get',
    params: parameter
  })
}

/**
 * AI反光背心监测告警数据
 * @param {object} parameter
 */
export function getListAIReflectiveVest (parameter) {
  return request({
    url: `iot/WarningData/listAIReflectiveVest`,
    method: 'get',
    params: parameter
  })
}

/**
 * AI吸烟监测告警数据
 * @param {object} parameter
 */
export function getListAISmoking (parameter) {
  return request({
    url: `iot/WarningData/listAISmoking`,
    method: 'get',
    params: parameter
  })
}

/**
 * AI打电话监测告警数据
 * @param {object} parameter
 */
export function getListAiCall (parameter) {
  return request({
    url: `iot//WarningData/listAiCall`,
    method: 'get',
    params: parameter
  })
}

/**
 * 临电管理
 * @param {object} parameter
 */
export function getAlarmData (parameter) {
  return request({
    url: `iot/WarningData/getAlarmData`,
    method: 'get',
    params: parameter
  })
}

/**
 * AI安全帽告警-处理告警数据
 * @param {object} parameter
 */
export function updateProcessStatus (parameter) {
  return request({
    url: `iot/WarningData/updateProcessStatus`,
    method: 'put',
    data: parameter
  })
}

/**
 * AI监控预警记录 - 查询海康ISC告警记录
 * @param {object} parameter
 * @property {String} alarmType 告警类型
 * @property {String} startDate 开始时间
 * @property {String} endDate  结束时间
 */
 export function postListEventRecord (parameter) {
  return request({
    url: `iot/device/listISUPRecord`,
    method: 'post',
    data: parameter
  })
}

/**
 * AI火焰监测
 * @param {object} parameter
 * @property {String} alarmType 告警类型
 * @property {array[string]} deviceIds 设备id
 * @property {String} startDate 开始时间
 * @property {String} endDate  结束时间
 */
 export function postListAIFire (parameter) {
  return request({
    url: `/AY220052Z/HikvisionDevice/listAIFire`,
    method: 'post',
    data: parameter
  })
}

/**
 * AI禁区闯入监测
 * @param {object} parameter
 * @property {String} alarmType 告警类型
 * @property {array[string]} deviceIds 设备id
 * @property {String} startDate 开始时间
 * @property {String} endDate  结束时间
 */
 export function postListAIRestricted (parameter) {
  return request({
    url: `/AY220052Z/HikvisionDevice/listAIRestricted`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【龙门吊管理】列表
 * @param {object} parameter
 */
export function getGantryCraneAlarmList (parameter) {
  return request({
    url: `iot/WarningData/selectGantryCraneAlarm`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【龙门吊管理】监测点列表
 * @param {object} parameter
 */
 export function GantryCraneDeviceList (parameter) {
  return request({
    url: `/beam/GantryCraneDevice/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【智慧大屏-安全管理】【龙门吊管理】监测点信息
 * @param {object} parameter
 */
export function selectGantryCraneChart (parameter) {
  return request({
    url: `/beam/GantryCraneDevice/selectGantryCraneChart/${parameter.deviceId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【龙门吊管理】监测点信息
 * @param {object} parameter
 */
 export function getByDeviceId (parameter) {
  return request({
    url: `/beam/GantryCraneDevice/getByDeviceId/${parameter.deviceId}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【龙门吊管理】预警信息
 * @param {object} parameter
 * @property {String} startDate 开始时间
 * @property {String} endDate  结束时间
 * @property {String} warningType 预警类型
 * @property {String} deviceId 设备id
 */
 export function selectGantryCraneAlarm (parameter) {
  return request({
    url: `/beam/GantryCraneDevice/selectGantryCraneAlarm`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【临电管理】监测点
 * @param {object} parameter
 */
 export function LianElectricity (parameter) {
  return request({
    url: `/beam/LianElectricity/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【临电管理】实时数据
 * @param {object} parameter
 * @property {String} partId 设备id
 */
 export function getRealTimeData (parameter) {
  return request({
    url: `/beam/LianElectricity/getRealTimeData`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【临电管理】实时数据
 * @param {object} parameter
 * @property {String} startTime 开始时间
 * @property {String} endTime 结束时间
 * @property {String} exceptionType 类型 1预警 2报警 3故障 4消防主机部件
 * @property {String} state 类型 1处理中 2已解决 3误报
 */
 export function listLiAnRecord (parameter) {
  return request({
    url: `/beam/LianElectricity/listLiAnRecord`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【临电管理】获取今日用电情况
 * @param {object} parameter
 * @property {String} partId 设备id
 * @property {String} pointName 点名称
 */
 export function electricityConsumption (parameter) {
  return request({
    url: `/beam/LianElectricity/electricityConsumption`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【临电管理】获取今日温度情况
 * @param {object} parameter
 * @property {String} partId 设备id
 * @property {String} pointName 点名称
 */
 export function temperatureConsumption (parameter) {
  return request({
    url: `/beam/LianElectricity/temperatureConsumption`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【安全管理】-【视频监控】- 获取视频直播地址
 * @param {object} parameter
 * @property {String} placeName 监控名称
 * @property {String} channel 通道号
 */
 export function getListBroadcastAddress (parameter) {
  return request({
    url: `/AY220052Z/HikvisionDevice/listBroadcastAddress`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-【视频监控】- 获取单个视频播放地址
 * @param {object} parameter
 * @property {String} deviceSerial 设备编号
 * @property {String} channel 通道号
 * @property {number} type 类型 (1-直播地址, 2-回放地址) 默认1
 * @property {String} beginTime 开始时间 (yyyy-MM-dd HH:mm:ss)
 * @property {String} endTime 结束时间 (yyyy-MM-dd HH:mm:ss)
 */
 export function getRecVideoAddress (parameter) {
  return request({
    url: `/AY220052Z/HikvisionDevice/getRecVideoAddress`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【安全管理】-【视频监控】- 云台控制
 * @param {object} parameter
 * @property {String} deviceSerial 设备编号
 * @property {String} channelNo 通道号
 * @property {number} direction 操作命令：0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-近焦距，11-远焦距，12-停止
 * @property {number} speed 云台速度：1-适中，2-快（默认1）
 */
 export function ptzControl (parameter) {
  return request({
    url: `/AY220052Z/HikvisionDevice/ptzControl`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-【视频监控】- 修改监控属性（枪机/球机）
 * @param {object} parameter
 * @property {number} cameraType 监控属性（1-枪机 2-球机）
 * @property {number} id 设备ID
 */
export function updateCameraType (parameter) {
  return request({
    url: `/AY220052Z/HikvisionDevice/updateCameraType`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【安全管理】-【项目信息管理】- 项目相关方信息详情
 * @param {object} parameter
 * @property {number} orgId 组织id
 */
export function getProjectRelatedDetailInfo (parameter) {
  return request({
    url: `/org/ProjectRelatedInfo/listProjectRelated/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-【项目信息管理】- 项目相关方信息保存
 * @param {object} parameter
 */
export function saveProjectRelatedDetail (parameter) {
  return request({
    url: `/org/ProjectRelatedInfo/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【安全管理】-【项目信息管理】- 项目合规性相关证件办理情况情况详情
 * @param {object} parameter
 * @property {number} orgId 组织id
 */
export function getProjectDocumentDetailInfo (parameter) {
  return request({
    url: `/org/ProjectDocumentTransaction/getByOrgId/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-【项目信息管理】- 项目合规性相关证件办理情况情况保存
 * @param {object} parameter
 */
export function saveProjectDocumentDetail (parameter) {
  return request({
    url: `/org/ProjectDocumentTransaction/compile`,
    method: 'put',
    data: parameter
  })
}

/**
 * 【安全管理】-【项目信息管理】- 工程概况详情
 * @param {object} parameter
 * @property {number} orgId 组织id
 */
export function getProjectOverviewDetailInfo (parameter) {
  return request({
    url: `/org/ProjectOverview/getProjectOverviewByOrgId/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-【项目信息管理】- 工程概况保存
 * @param {object} parameter
 */
export function saveProjectOverviewDetail (parameter) {
  return request({
    url: `/org/ProjectOverview/`,
    method: 'post',
    data: parameter
  })
}

// -----------------------------------------------苏台二七--------------------------------------------------
/**
 * 获取设备列表(张拉、压浆)
 * @param {object} parameter
 * @property {Number} type 1张拉 2压浆
 */
export function listShebeibianhao (parameter) {
  return request({
    url: `/AY220054Z/Device/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 获取张拉设备数据
 * @param {object} parameter
 * @property {Number} id 梁号id
 * @property {Number} shebeibianhao 设备编号
 */
 export function getZlByLCInfo (parameter) {
    return request({
      url: '/AY220054Z/lcdevice/getZlByLC',
      method: 'post',
      data: parameter
    })
  }
  /**
 * 获取压浆设备数据
 * @param {object} parameter
 * @property {Number} id 梁号id
 * @property {Number} shebeibianhao 设备编号
 */
 export function getYJByLCInfo (parameter) {
  return request({
    url: '/AY220054Z/lcdevice/getYJByLC',
    method: 'post',
    data: parameter
  })
}
/**
 * 获取抽屉内的数据
 * @param {object} parameter
 * @property {Number} shebeibianhao 设备编号
 */
 export function getDrawerData (parameter) {
  return request({
    url: `/AY220054Z/lcdevice/getDrawerData/${parameter.shebeibianhao}`,
    method: 'get'
  })
}
/**
 * 张拉压浆编辑
 * @param {object} parameter
 * @property {Number} shebeibianhao 设备编号
 */
 export function updateZLOrYJ (parameter) {
  return request({
    url: `/AY220054Z/lcdevice/updateZLOrYJ`,
    method: 'post',
    data: parameter
  })
}
/**
 * 获取抽屉内数据(数组)
 * @param {object} parameter
 * @property {String} startTime 开始时间
 * @property {String} endTime 结束时间
 * @property {number} shebeibianhao 设备编号
 */
export function getDrawerDataByDTO (parameter) {
  return request({
    url: `/AY220054Z/lcdevice/getDrawerDataByDTO`,
    method: 'post',
    data: parameter
  })
}

// --------------------------高支模------------------------------

/**
 * 【安全管理】-高支模-查询高支模监测列表——实时数据
 * @param {object} parameter
 */
export function getListRealHighFormwork (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/listRealHighFormwork`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--各测点告警次数
 * @param {object} parameter
 */
export function getWarnCount (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/getWarnCount`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--各测点告警占比
 * @param {object} parameter
 */
export function getWarnPercentage (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/getWarnPercentage`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--各测点极值
 * @param {object} parameter
 */
export function getPeakData (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/getPeakData`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--查询高支模检测表告警记录列表
 * @param {object} parameter
 */
export function getListHighFormworkWarning (parameter) {
  return request({
    url: `/AY220052Z/HighFormworkWarning/listHighFormworkWarning`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--查询高支模监测列表——实时数据
 * @param {object} parameter
 */
export function getListHighFormwork (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/listHighFormwork`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--根据id删除高支模监测
 * @param parameter
 */
export function deleteHighFormworkById (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【安全管理】-高支模--查询高支模监测详情
 * @param {object} parameter
 */
export function getHighFormworkById (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】-高支模--保存高支模监测
 * @param parameter
 */
export function postSaveHighFormwork (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【安全管理】-高支模--修改高支模监测
 * @param parameter
 */
export function updateHighFormwork (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 【安全管理】-高支模--测点详情页面
 * @param {object} parameter
 */
export function getDetailInfo (parameter) {
  return request({
    url: `/AY220052Z/HighFormwork/getDetailInfo`,
    method: 'get',
    params: parameter
  })
}

// 安全会议

/**
 * 查询应急会议附件管理表列表
 * @param {object} parameter
 */
export function getSecurityConferenceList (parameter) {
  return request({
    url: '/user/SecurityConference/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 根据id删除应急会议附件管理表
 * @param {object} parameter
 */
export function deleteSecurityConferenceById (parameter) {
  return request({
    url: `/user/SecurityConference/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存应急会议附件管理表
 * @param {object} parameter
 */
export function saveSecurityConference (parameter) {
  return request({
    url: `/user/SecurityConference/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改应急会议附件管理表
 * @param {object} parameter
 */
export function updateSecurityConference (parameter) {
  return request({
    url: `/user/SecurityConference/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询应急会议附件管理表详情
 * @param {object} parameter
 */
export function getSecurityConferenceById (parameter) {
  return request({
    url: `/user/SecurityConference/${parameter.id}`,
    method: 'get'
  })
}

// --------------------------边坡监测------------------------------

/**
 * 查询边坡监测列表
 * @param {object} parameter
 */
export function getSlopeMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 今日监测信息
 * @param {object} parameter
 */
export function getSlopeMonitoringToday (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/slopeMonitoringToday',
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测近七日监测
 * @param {object} parameter
 */
export function getSlopeMonitoringPast7Days (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/slopeMonitoringPast7Days',
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测近七日监测
 * @param {object} parameter
 */
export function getslopeMonitoringPast (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/slopeMonitoringPast',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询边坡监测阈值表列表
 * @param {object} parameter
 */
export function getSlopeMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringThreshold/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测预警值设置
 * @param {object} parameter
 */
export function putSlopeMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringThreshold/',
    method: 'put',
    data: parameter
  })
}

/**
 * 预警记录
 * @param {object} parameter
 * @property {number} warnDeviceType 预警设备类型 1-边坡监测 2-应力监测 3-沉降监测 4-缆绳吊监测 5-水土流失监测 6-气体监测 7-一般设备监测
 */
export function getDeviceWarnList (parameter) {
  return request({
    url: '/machineryMgt/iot/DeviceWarn/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 预警记录 批量处理（ZY250117- 新疆路桥s12高托巴9标隧道信息化系统）
 * @param {object} parameter
 */
export function oneClickProcessing (parameter) {
  return request({
    url: '/machineryMgt/iot/DeviceWarn/oneClickProcessing',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改预警设备
 * @param {object} parameter
 * @property {number} warnDeviceType 预警设备类型 1-边坡监测 2-应力监测 3-沉降监测 4-缆绳吊监测 5-水土流失监测 6-气体监测 7-一般设备监测
 */
export function postDeviceWarn (parameter) {
  return request({
    url: '/machineryMgt/iot/DeviceWarn/',
    method: 'put',
    data: parameter
  })
}

/**
 * 监测点位备选项列表
 * @param {object} parameter
 * @property {number} deviceType 预警设备类型 1-边坡监测 2-应力监测 3-沉降监测 4-缆绳吊监测 5-水土流失监测 6-气体监测 7-一般设备监测
 */
export function getMonitorPointsList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/getMonitorPointsList',
    method: 'get',
    params: parameter
  })
}

/**
 * 今日监测信息-新接口（ZY250128-贵州路桥 兴义长江大桥 v3.1.0迭代）
 * @param {object} parameter
 */
export function slopeMonitoringTodayWithGroup (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoring/slopeMonitoringTodayWithGroup',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询边坡监测设备分组表列表
 * @param {object} parameter
 */
export function getSlopeMonitoringDeviceGroupList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringDeviceGroup/list',
    method: 'get',
    params: Object.assign({ appCode }, parameter)
  })
}

/**
 * 保存边坡监测设备分组
 * @param {object} parameter
 */
export function saveBatchSlopeMonitoringDeviceGroup (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringDeviceGroup/saveBatch',
    method: 'post',
    data: Object.assign({ appCode }, parameter)
  })
}

// --------------------------应力监测------------------------------

/**
 * 查询应力监测列表
 * @param {object} parameter
 */
export function getStressMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/StressMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 今日监测信息
 * @param {object} parameter
 */
export function getStressMonitoringToday (parameter) {
  return request({
    url: '/machineryMgt/iot/StressMonitoring/stressMonitoringToday',
    method: 'get',
    params: parameter
  })
}

/**
 * 应力监测近七日监测
 * @param {object} parameter
 */
export function getStressMonitoringPast7Days (parameter) {
  return request({
    url: '/machineryMgt/iot/StressMonitoring/stressMonitoringPast7Days',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询应力监测阈值表列表
 * @param {object} parameter
 */
export function getStressMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/StressMonitoringThreshold/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 应力监测预警值设置
 * @param {object} parameter
 */
export function putStressMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/StressMonitoringThreshold/',
    method: 'put',
    data: parameter
  })
}

// #region --------------------------沉降监测------------------------------

/**
 * 查询沉降监测列表
 * @param {object} parameter
 */
export function getSettlementMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/SettlementMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 今日监测信息
 * @param {object} parameter
 */
export function getSettlementMonitoringToday (parameter) {
  return request({
    url: '/machineryMgt/iot/SettlementMonitoring/settlementMonitoringToday',
    method: 'get',
    params: parameter
  })
}

/**
 * 沉降监测近七日监测
 * @param {object} parameter
 */
export function getSettlementMonitoringPast7Days (parameter) {
  return request({
    url: '/machineryMgt/iot/SettlementMonitoring/settlementMonitoringPast7Days',
    method: 'get',
    params: parameter
  })
}

/**
 * 预警值
 * @param {object} parameter
 */
export function putSettlementMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/SettlementMonitoringThreshold/',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询沉降监测阈值表列表
 * @param {object} parameter
 */
export function getSettlementMonitoringThresholdList (parameter) {
  return request({
    url: '/machineryMgt/iot/SettlementMonitoringThreshold/list',
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------水土流失监测------------------------------

/**
 * 查询水土流失监测列表
 * @param {object} parameter
 */
export function getSoilErosionMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/SoilErosionMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 今日监测信息
 * @param {object} parameter
 */
export function getSoilErosionMonitorToday (parameter) {
  return request({
    url: '/machineryMgt/iot/SoilErosionMonitoring/soilErosionMonitorToday',
    method: 'get',
    params: parameter
  })
}

/**
 * 水土流失监测近七日监测
 * @param {object} parameter
 */
export function getSoilErosionMonitorPast7Days (parameter) {
  return request({
    url: '/machineryMgt/iot/SoilErosionMonitoring/soilErosionMonitorPast7Days',
    method: 'get',
    params: parameter
  })
}

/**
 * 预警值
 * @param {object} parameter
 */
export function putSoilErosionMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/SoilErosionMonitoringThreshold/',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询沉降监测阈值表列表
 * @param {object} parameter
 */
export function getSoilErosionMonitoringThresholdList (parameter) {
  return request({
    url: '/machineryMgt/iot/SoilErosionMonitoringThreshold/list',
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------缆绳吊监测------------------------------

/**
 * 查询缆绳吊监测列表
 * @param {object} parameter
 */
export function getCableCraneMonitoringList (parameter) {
  return request({
    url: '/machineryMgt/iot/CableCraneMonitoring/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 缆绳吊监测近七日监测
 * @param {object} parameter
 */
export function getCableCraneMonitoringPast7Days (parameter) {
  return request({
    url: '/machineryMgt/iot/CableCraneMonitoring/cableCraneMonitoringPast7Days',
    method: 'get',
    params: parameter
  })
}

/**
 * 预警值
 * @param {object} parameter
 */
export function putCableCraneMonitoringThreshold (parameter) {
  return request({
    url: '/machineryMgt/iot/CableCraneMonitoringThreshold/',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询缆绳吊监测阈值表列表
 * @param {object} parameter
 */
export function getCableCraneMonitoringThresholdList (parameter) {
  return request({
    url: '/machineryMgt/iot/CableCraneMonitoringThreshold/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询设备编号
 * @param {object} parameter
 */
export function getDeviceList (parameter) {
  return request({
    url: '/machineryMgt/iot/CableCraneMonitoring/getDeviceList',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询缆绳吊监测监控列表
 * @param {object} parameter
 */
export function getCableCraneMonitorMonitorList (parameter) {
  return request({
    url: '/machineryMgt/iot/CableCraneMonitorMonitor/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-获取预警配置列表
 */
export function listSlopeMonitorRecordWarnConfig (parameter) {
  return request({
    url: 'machineryMgt/iot/SlopeMonitorRecordWarnConfig/listSlopeMonitorRecordWarnConfig',
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-保存获取预警配置
 */
export function updateSlopeMonitorRecordWarnConfig (parameter) {
  return request({
    url: 'machineryMgt/iot/SlopeMonitorRecordWarnConfig/updateSlopeMonitorRecordWarnConfig',
    method: 'put',
    data: parameter
  })
}

/**
 * 边坡监测记录-上传监测分析-位置图
 */
export function monitoringPicUpload (parameter) {
  return request({
    url: 'machineryMgt/iot/SlopeMonitoringRecord/monitoringPicUpload',
    method: 'post',
    data: parameter
  })
}

/**
 * 边坡监测记录-查询监测分析-位置图
 */
export function getMonitoringPicList (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMonitoringRecord/monitoringPicList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-监测分析-数据趋势图
 */
export function trendChartData (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMonitoringRecord/trendChartData`,
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-预警结论-测量数据
 */
export function getMeasurementData (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMonitoringRecord/getMeasurementData`,
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-预警结论-预警列表
 */
export function listSlopeMonitorRecordWarn (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMonitorRecordWarn/listSlopeMonitorRecordWarn`,
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-预警结论-测量结论列表
 */
export function listSlopeMeasurementConclusion (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMeasurementConclusion/listSlopeMeasurementConclusion`,
    method: 'get',
    params: parameter
  })
}

/**
 * 边坡监测记录-预警结论-保存测量结论
 */
export function saveSlopeMeasurementConclusion (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMeasurementConclusion/saveSlopeMeasurementConclusion`,
    method: 'post',
    data: parameter
  })
}

/**
 * 边坡监测记录-预警结论-编辑测量结论
 */
export function updateSlopeMeasurementConclusion (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMeasurementConclusion/updateSlopeMeasurementConclusion`,
    method: 'put',
    data: parameter
  })
}

/**
 * 边坡监测记录-预警结论-查看测量结论
 */
export function getSlopeMeasurementConclusionById (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMeasurementConclusion/getSlopeMeasurementConclusionById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 边坡监测记录-预警结论-删除测量结论
 */
export function deleteSlopeMeasurementConclusionById (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMeasurementConclusion/deleteSlopeMeasurementConclusionById/ ${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 边坡监测记录-预警结论-导出边坡监测记录预警信息excel
 */
export function importSlopeMonitorRecordWarn (parameter) {
  return request({
    url: `machineryMgt/file/excel/importSlopeMonitorRecordWarn`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询监测场地列表
 */
export function getSlopeMonitoringVenueList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringVenue/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 保存监测场地
 */
export function saveSlopeMonitoringVenue (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringVenue/',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改监测场地
 */
export function updateSlopeMonitoringVenue (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringVenue/',
    method: 'put',
    data: parameter
  })
}

/**
 * 查看监测场地
 */
export function getSlopeMonitoringVenue (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringVenue/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 删除监测场地
 */
export function deleteSlopeMonitoringVenueById (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringVenue/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 查询执法记录仪设备表列表
 * @param {object} parameter
 */
export function getLawEnforcementDeviceList (parameter) {
  return request({
    url: `/beam/LawEnforcementDevice/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【执法记录仪】详情
 * @param {object} parameter
 */
export function liveStreaming (parameter) {
  return request({
    url: '/beam/LawEnforcementDevice/liveStreaming',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询执法记录仪数据表列表
 * @param {object} parameter
 */
export function getLawEnforcementData (parameter) {
  return request({
    url: `/beam/LawEnforcementData/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改执法记录仪设备表
 * @param {object} parameter
 */
export function updateLawEnforcementDevice (parameter) {
  return request({
    url: `/beam/LawEnforcementDevice/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 查询用户列表
 * @param {object} parameter
 */
export function getUserList (parameter) {
  return request({
    url: `/user/User/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 导入
 */
export function importExcel (parameter) {
  return request({
    url: `/file/excel/importExcel`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询本次测量测量时间是否被使用
 */
export function judgeMonitoringTimeIsUse (parameter) {
  return request({
    url: `machineryMgt/iot/SlopeMonitoringRecord/judgeMonitoringTimeIsUse`,
    method: 'get',
    params: parameter
  })
}

/**
 * 导入
 */
export function importExcelNew (parameter) {
  return request({
    url: `/file/excel/importExcelNew`,
    timeout: 2 * 60 * 1000,
    method: 'post',
    data: parameter
  })
}

/**
 * 梁生产管理的导入
 */
export function syncImportExcel (parameter) {
  return request({
    url: `/beam-production-sys/production/importFile/syncImportExcel`,
    timeout: 2 * 60 * 1000,
    method: 'post',
    data: parameter
  })
}

/**
 * 导出
 */
export function exportObservationRecordExcel (parameter) {
  return request({
    url: `/file/excel/exportObservationRecordExcel`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询观测记录主表列表
 */
export function getSlopeMonitoringRecordList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringRecord/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询观测记录主表子列表
 */
export function getSlopeMonitoringMeasuredValueList (parameter) {
  return request({
    url: '/machineryMgt/iot/SlopeMonitoringMeasuredValue/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 根据id删除观测记录主表
 */
export function deleteSlopeMonitoringRecordById (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringRecord/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 查询初始测量值列表
 */
export function getSlopeMonitoringInitialValueList (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringInitialValue/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 查询配置点位列表
 */
export function getSlopeMonitoringConfigValueList (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringConfigValue/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询配置点位列表
 */
export function listHistoryPointPosition (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringMeasuredValue/listHistoryPointPosition/${parameter.smVenueId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 新增配置点位
 */
export function saveSlopeMonitoringConfigValue (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringConfigValue/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改配置点位
 */
export function updateSlopeMonitoringConfigValue (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringConfigValue/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 删除配置点位
 */
export function deleteSlopeMonitoringConfigValueById (parameter) {
  return request({
    url: `/machineryMgt/iot/machineryMgt/iot/SlopeMonitoringConfigValue/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 配置点位 删除校验
 */
export function judgePointIsHave (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringConfigValue/judgePointIsHave`,
    method: 'post',
    data: parameter
  })
}

/**
 * 上次测量时间
 */
export function getSelectLastTimeById (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoringRecord/selectLastTime/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 删除边坡监测历史记录
 */
export function deleteSlopeMonitoringById (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoring/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存边坡监测
 */
export function saveSlopeMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoring/saveList`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改边坡监测
 */
export function updateSlopeMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/SlopeMonitoring/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 保存应力监测
 */
export function saveStressMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/StressMonitoring/saveList`,
    method: 'post',
    data: parameter
  })
}

/**
 * 保存缆绳吊监测
 */
export function saveCableCraneMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/CableCraneMonitoring/saveList`,
    method: 'post',
    data: parameter
  })
}

/**
 * 保存水土流失监测
 */
export function saveSoilErosionMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/SoilErosionMonitoring/saveList`,
    method: 'post',
    data: parameter
  })
}

/**
 * 保存沉降监测
 */
export function saveSettlementMonitoring (parameter) {
  return request({
    url: `/machineryMgt/iot/SettlementMonitoring/saveList`,
    method: 'post',
    data: parameter
  })
}
// #endregion

/**
 * 构件问题 - 新增
 */
export function saveComponentProblemLibrary (parameter) {
  return request({
    url: `/materials/ComponentProblemLibrary/saveComponentProblemLibrary`,
    method: 'post',
    data: parameter
  })
}
/**
 * 构件问题 - 删除
 */
export function deleteComponentProblemLibraryById (parameter) {
  return request({
    url: `/materials/ComponentProblemLibrary/deleteComponentProblemLibraryById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 构件问题 - 查看
 */
export function getComponentProblemLibraryById (parameter) {
  return request({
    url: `/materials/ComponentProblemLibrary/getComponentProblemLibraryById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 构件问题 - 列表
 */
export function listComponentProblemLibrary (parameter) {
  return request({
    url: `/materials/ComponentProblemLibrary/listComponentProblemLibrary`,
    method: 'get',
    params: parameter
  })
}
/**
 * 构件问题 - 修改
 */
export function updateComponentProblemLibrary (parameter) {
  return request({
    url: `/materials/ComponentProblemLibrary/updateComponentProblemLibrary`,
    method: 'put',
    data: parameter
  })
}
/**
 * 构件问题类型 - 新增
 */
export function saveComponentProblemType (parameter) {
  return request({
    url: `/materials/ComponentProblemType/saveComponentProblemType`,
    method: 'post',
    data: parameter
  })
}
/**
 * 构件问题类型 - 修改
 */
export function updateComponentProblemType (parameter) {
  return request({
    url: `/materials/ComponentProblemType/updateComponentProblemType`,
    method: 'put',
    data: parameter
  })
}
/**
 * 构件问题类型 - 删除
 */
export function deleteComponentProblemTypeById (parameter) {
  return request({
    url: `/materials/ComponentProblemType/deleteComponentProblemTypeById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 构件问题类型 - 查看
 */
export function getComponentProblemTypeById (parameter) {
  return request({
    url: `/materials/ComponentProblemType/getComponentProblemTypeById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 构件问题类型 - 列表
 */
export function listComponentProblemType (parameter) {
  return request({
    url: `/materials/ComponentProblemType/listComponentProblemType`,
    method: 'get',
    params: parameter
  })
}

// #region --------------------------入职培训与安全交底------------------------------

/**
 * 保存入职培训与安全教育
 * @param {object} parameter
 */
export function saveEmploymentTrain (parameter) {
  return request({
    url: '/user/EmploymentTrain/saveEmploymentTrain',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改入职培训与安全教育
 * @param {object} parameter
 */
export function updateEmploymentTrain (parameter) {
  return request({
    url: '/user/EmploymentTrain/updateEmploymentTrain',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询入职培训与安全教育列表
 * @param {object} parameter
 */
export function getEmploymentTrainList (parameter) {
  return request({
    url: '/user/EmploymentTrain/listEmploymentTrain',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询入职培训与安全教育详情
 * @param {object} parameter
 */
export function getEmploymentTrainById (parameter) {
  return request({
    url: `/user/EmploymentTrain/getEmploymentTrainById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 删除入职培训与安全教育
 * @param {object} parameter
 */
export function deleteEmploymentTrainById (parameter) {
  return request({
    url: `/user/EmploymentTrain/deleteEmploymentTrainById/${parameter.id}`,
    method: 'delete'
  })
}

// #endregion

// #region --------------------------智能螺栓监测------------------------------

/**
 * 智能螺栓列表
 * @param {object} parameter
 */
export function getNutMonitorList (parameter) {
  return request({
    url: `iot/NutMonitor/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 智能螺栓预警列表
 * @param {object} parameter
 */
export function getNutMonitorWarnList (parameter) {
  return request({
    url: `iot/NutMonitor/getNutMonitorWarnList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 智能螺栓预警列表
 * @param {object} parameter
 */
export function getListTotalNum (parameter) {
  return request({
    url: `iot//NutMonitor/listTotalNum`,
    method: 'get',
    params: parameter
  })
}

// #endregion

/**
 * 查询高支模检测表告警记录列表
 * @param {object} parameter
 */
export function getHighFormworkWarningList (parameter) {
  return request({
    url: '/AY220052Z/HighFormworkWarning/listHighFormworkWarning',
    method: 'get',
    params: parameter
  })
}

/**
 * 保存高支模检测表告警记录
 * @param {object} parameter
 */
export function saveHighFormworkWarning (parameter) {
  return request({
    url: '/AY220052Z/HighFormworkWarning/saveHighFormworkWarning',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑高支模检测表告警记录
 * @param {object} parameter
 */
export function updateHighFormworkWarning (parameter) {
  return request({
    url: '/AY220052Z/HighFormworkWarning/updateHighFormworkWarning',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询高支模检测表
 * @param {object} parameter
 */
export function getHighFormworkWarningById (parameter) {
  return request({
    url: `/AY220052Z/HighFormworkWarning/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 删除高支模检测表
 * @param {object} parameter
 */
export function deletetHighFormworkWarningById (parameter) {
  return request({
    url: `/AY220052Z/HighFormworkWarning/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 测温设备列表
 * @param {object} parameter
 */
export function getThermometryDeviceList (parameter) {
  return request({
    url: `iot/DeviceThermometry/thermometryDeviceList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 测温设备实时监测
 * @param {object} parameter
 */
export function getThermometryDeviceMonitor (parameter) {
  return request({
    url: `iot/DeviceThermometry/thermometryDeviceMonitor`,
    method: 'get',
    params: parameter
  })
}

/**
 * 温度变化监测
 * @param {object} parameter
 */
export function getThermometryDeviceRecord (parameter) {
  return request({
    url: `iot/DeviceThermometry/thermometryDeviceMonitorRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询测温PT100（钢板温度）列表
 * @param {object} parameter
 */
export function getDeviceThermometryList (parameter) {
  return request({
    url: `iot/DeviceThermometry/listDeviceThermometry`,
    method: 'get',
    params: parameter
  })
}

// #region --------------------------龙门吊管理（葫芦吊）------------------------------

/**
 * 查询龙门吊管理（葫芦吊）设备状态
 * @param {object} parameter
 */
export function getCalabashCraneHangHeavy (parameter) {
  return request({
    url: `machineryMgt/iot/CalabashCraneManage/getCalabashCraneHangHeavy/${parameter.deviceId}`,
    method: 'get'
  })
}

/**
 * 实时吊重
 * @param {object} parameter
 */
export function getCalabashCraneState (parameter) {
  return request({
    url: `machineryMgt/iot/CalabashCraneManage/getCalabashCraneState/${parameter.deviceId}`,
    method: 'get'
  })
}

/**
 * 查询龙门吊管理（葫芦吊）列表
 * @param {object} parameter
 */
export function getListCalabashCraneManage (parameter) {
  return request({
    url: `machineryMgt/iot/CalabashCraneManage/listCalabashCraneManage`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询龙门吊管理（葫芦吊）预警列表
 * @param {object} parameter
 */
export function getListCalabashCraneWarn (parameter) {
  return request({
    url: `machineryMgt/iot/CalabashCraneWarn/listCalabashCraneWarn`,
    method: 'get',
    params: parameter
  })
}

/**
 * 更新龙门吊管理（葫芦吊）预警列表
 * 测温设备-获取空气温度
 * @param {object} parameter
 */
export function getAirTemperature (parameter) {
  return request({
    url: `iot/DeviceThermometry/getAirTemperature/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 测温设备-获取统计数据
 * @param {object} parameter
 */
export function getThermometryDataStatistics (parameter) {
  return request({
    url: `iot/DeviceThermometry/dataStatistics`,
    method: 'get',
    params: parameter
  })
}

/**
 * 测温设备-获取统计数据-导出
 * @param {object} parameter
 */
export function exportDeviceThermometryStatistics (parameter) {
  return request({
    url: `file/excel/exportDeviceThermometryStatistics`,
    method: 'get',
    params: parameter
  })
}

/**
 * 温度变化监测
 * @param {object} parameter
 */
export function updateCalabashCraneWarn (parameter) {
  return request({
    url: `machineryMgt/iot/CalabashCraneWarn/updateCalabashCraneWarn`,
    method: 'put',
    data: parameter
  })
}

/**
 * 龙门吊管理（葫芦吊）预警列表-一键处理
 * @param {object} parameter
 */
export function oneClickProcess (parameter) {
  return request({
    url: `machineryMgt/iot/CalabashCraneWarn/oneClickProcess/${parameter.ids}/${parameter.status}`,
    method: 'get'
  })
}

// #region --------------------------AI安全带监测------------------------------
/**
 * 查询AI安全带监测列表
 * @param {object} parameter
 */
export function getListAIFivePointSeatBelt (parameter) {
  return request({
    url: `iot/WarningData/listAIFivePointSeatBelt`,
    method: 'get',
    params: parameter
  })
}
// #endregion

// #region --------------------------AI安全帽反光衣监测------------------------------
/**
 * 查询AI安全帽反光衣监测列表
 * @param {object} parameter
 */
export function listSafeHatReflectVest (parameter) {
  return request({
    url: `/iot/WarningData/listSafeHatReflectVest`,
    method: 'get',
    params: parameter
  })
}
// #endregion

// #region --------------------------应急预案------------------------------
/**
 * 查询应急预案管理列表
 * @param {object} parameter
 */
export function getListEmergencyPlanManage (parameter) {
  return request({
    url: `/sys/EmergencyPlanManage/listEmergencyPlanManage`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询应急预案管理详情
 * @param {object} parameter
 */
export function getEmergencyPlanManageById (parameter = {}) {
  return request({
    url: `/sys/EmergencyPlanManage/getEmergencyPlanManageById/${parameter.id}`,
    method: 'get',
    params: { dataPermission: '/emergencyPlan', ...parameter }
  })
}

/**
 * 保存应急预案管理
 * @param {object} parameter
 */
export function saveEmergencyPlanManage (parameter) {
  return request({
    url: '/sys/EmergencyPlanManage/saveEmergencyPlanManage',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改应急预案管理
 * @param {object} parameter
 */
export function updateEmergencyPlanManage (parameter) {
  return request({
    url: '/sys/EmergencyPlanManage/updateEmergencyPlanManage',
    method: 'put',
    data: parameter
  })
}

/**
 * 根据id删除应急预案管理
 * @param {object} parameter
 */
export function deleteEmergencyPlanManageById (parameter) {
  return request({
    url: `/sys/EmergencyPlanManage/deleteEmergencyPlanManageById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 启动应急预案
 * @param {object} parameter
 */
export function startEmergencyPlanManage (parameter) {
  return request({
    url: `/sys/EmergencyPlanManage/startEmergencyPlanManage/${parameter.id}`,
    method: 'post',
    data: parameter
  })
}
// #endregion

// #region --------------------------应急记录------------------------------
/**
 * 查询应急预案记录列表
 * @param {object} parameter
 */
export function getListEmergencyPlanManageRecord (parameter) {
  return request({
    url: `/sys/EmergencyPlanManageRecord/listEmergencyPlanManageRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询应急预案记录详情
 * @param {object} parameter
 */
export function getEmergencyPlanManageRecordById (parameter = {}) {
  return request({
    url: `/sys/EmergencyPlanManageRecord/getEmergencyPlanManageRecordById/${parameter.id}`,
    method: 'get',
    params: { dataPermission: '/emergencyRecord', ...parameter }
  })
}
// #endregion

/**
 * AI工序识别实时进度-获取最新信息
 * @param {object} parameter
 */
export function getAiRealtimeProgress (parameter = {}) {
  return request({
    url: `beam-production-sys/production/AiProcessIdentify/getAiRealtimeProgress`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

// #region --------------------------车辆进出管理------------------------------

/**
 * 获取车辆类型占比数据
 * @param {object} parameter
 */
export function typeRatio (parameter = {}) {
  return request({
    url: `sys/VehicleAccessRecords/typeRatio`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 获取车牌类型占比数据
 * @param {object} parameter
 */
export function plateRatio (parameter = {}) {
  return request({
    url: `sys/VehicleAccessRecords/plateRatio`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 近12小时车辆进场/出场分时统计
 * @param {object} parameter
 */
export function hourlyTraffic (parameter = {}) {
  return request({
    url: `sys/VehicleAccessRecords/hourlyTraffic`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 查询车辆进出记录表列表
 * @param {object} parameter
 */
export function listVehicleAccessRecords (parameter = {}) {
  return request({
    url: `sys/VehicleAccessRecords/listVehicleAccessRecords`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 查询车辆进出记录表-获取位置列表
 * @param {object} parameter
 */
export function getPositionList (parameter = {}) {
  return request({
    url: `/sys/VehicleAccessRecords/getPositionList/${parameter.orgId}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 查询停车场车位状态记录表列表
 * @param {object} parameter
 */
export function listParkingLotStatus (parameter = {}) {
  return request({
    url: `sys/ParkingLotStatus/listParkingLotStatus`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 查询
 * @param {object} parameter
 */
export function mergedByOrgId (parameter = {}) {
  return request({
    url: `sys/VehicleAccessRecords/vehicleAccess/mergedByOrgId`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

// #endregion

// #region --------------------------位移监测------------------------------

/**
 * 查询位移预警值范围配置表（存储各测点X/Y/Z轴的预警阈值）列表
 * @param {object} parameter
 */
export function listDisplacementWarnConfig (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementWarnConfig/listDisplacementWarnConfig`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 修改位移预警值范围配置表（存储各测点X/Y/Z轴的预警阈值）
 * @param {object} parameter
 */
export function updateDisplacementWarnConfig (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementWarnConfig/batchUpdate`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 位移监测-获取各测点最新位移数据
 * @param {object} parameter
 */
export function getDisplacementMonitorLatestData (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/getLatestData`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 位移监测-获取位移监测分析数据
 * @param {object} parameter
 */
export function getDisplacementMonitorAnalysis (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/getMonitorAnalysis`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 位移监测-保存位移监测数据表（历史记录）
 * @param {object} parameter
 */
export function saveDisplacementMonitor (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}

/**
 * 位移监测-位移监测数据表（历史记录）列表
 * @param {object} parameter
 */
    export function listDisplacementMonitor (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/listDisplacementMonitor`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 位移监测-修改位移监测数据表（历史记录）
 * @param {object} parameter
 */
export function putDisplacementMonitor (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}

/**
 * 位移监测-查看位移监测数据表（历史记录）
 * @param {object} parameter
 */
export function getDisplacementMonitorById (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/getDisplacementMonitorById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 位移监测-删除位移监测数据表（历史记录）
 * @param {object} parameter
 */
export function deleteDisplacementMonitorById (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/deleteDisplacementMonitorById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 位移监测-测点下拉框数据
 * @param {object} parameter
 */
export function getMonitorPointsDropdown (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/monitorPointsDropdown`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 位移监测-桥段下拉框数据
 * @param {object} parameter
 */
export function getDisplacementMonitorBridgeList (parameter = {}) {
  return request({
    url: `machineryMgt/iot/DisplacementMonitor/displacementMonitor`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

// #endregion

// #region --------------------------碳排放管理（芜湖泰山路长江大桥项目）------------------------------

/**
 * 查询碳排放种类表
 * @param {object} parameter
 */
export function getCarbonEmissionCategoryList (parameter) {
  return request({
    url: `/sys/CarbonEmissionCategory/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询碳排放种类表详情
 * @param {object} parameter
 */
export function getCarbonEmissionCategoryById (parameter) {
  return request({
    url: `/sys/CarbonEmissionCategory/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除碳排放种类表
 * @param {object} parameter
 */
export function deleteCarbonEmissionCategoryById (parameter) {
  return request({
    url: `/sys/CarbonEmissionCategory/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存碳排放种类表
 * @param {object} parameter
 */
export function saveCarbonEmissionCategory (parameter) {
  return request({
    url: `/sys/CarbonEmissionCategory/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改碳排放种类表
 * @param {object} parameter
 */
export function updateCarbonEmissionCategory (parameter) {
  return request({
    url: `/sys/CarbonEmissionCategory/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询碳排放类型表列表
 * @param {object} parameter
 */
export function getCarbonEmissionTypeList (parameter) {
  return request({
    url: `/sys/CarbonEmissionType/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询碳排放类型表详情
 * @param {object} parameter
 */
export function getCarbonEmissionTypeById (parameter) {
  return request({
    url: `/sys/CarbonEmissionType/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除碳排放类型表
 * @param {object} parameter
 */
export function deleteCarbonEmissionTypeById (parameter) {
  return request({
    url: `/sys/CarbonEmissionType/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存碳排放类型表
 * @param {object} parameter
 */
export function saveCarbonEmissionType (parameter) {
  return request({
    url: `/sys/CarbonEmissionType/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改碳排放类型表
 * @param {object} parameter
 */
export function updateCarbonEmissionType (parameter) {
  return request({
    url: `/sys/CarbonEmissionType/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询碳排放管理单位表列表
 * @param {object} parameter dataCategory 1-碳排放因子单位 2-消耗量单位
 */
export function getCarbonEmissionUnitList (parameter) {
  return request({
    url: `/sys/CarbonEmissionUnit/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 碳排放管理单位详情
 * @param {object} parameter
 */
export function getCarbonEmissionUnitById (parameter) {
  return request({
    url: `/sys/CarbonEmissionUnit/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除碳排放管理单位
 * @param {object} parameter
 */
export function deleteCarbonEmissionUnitById (parameter) {
  return request({
    url: `/sys/CarbonEmissionUnit/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存碳排放管理单位
 * @param {object} parameter
 */
export function saveCarbonEmissionUnit (parameter) {
  return request({
    url: `/sys/CarbonEmissionUnit/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改碳排放管理单位
 * @param {object} parameter
 */
export function updateCarbonEmissionUnit (parameter) {
  return request({
    url: `/sys/CarbonEmissionUnit/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询碳排放施工部位表列表
 * @param {object} parameter
 */
export function getCarbonEmissionConstructionSiteList (parameter) {
  return request({
    url: `/sys/CarbonEmissionConstructionSite/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 碳排放施工部位表详情
 * @param {object} parameter
 */
export function getCarbonEmissionConstructionSiteById (parameter) {
  return request({
    url: `/sys/CarbonEmissionConstructionSite/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除碳排放施工部位表
 * @param {object} parameter
 */
export function deleteCarbonEmissionConstructionSiteById (parameter) {
  return request({
    url: `/sys/CarbonEmissionConstructionSite/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存碳排放施工部位表
 * @param {object} parameter
 */
export function saveCarbonEmissionConstructionSite (parameter) {
  return request({
    url: `/sys/CarbonEmissionConstructionSite/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改碳排放施工部位表
 * @param {object} parameter
 */
export function updateCarbonEmissionConstructionSite (parameter) {
  return request({
    url: `/sys/CarbonEmissionConstructionSite/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询未使用的【碳排放因子单位】数据
 * @param {object} parameter
 */
export function copyCarbonEmission (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/copyCarbonEmission/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询碳排放因子
 * @param {object} parameter
 */
export function getCarbonEmissionFactorList (parameter) {
  return request({
    url: `/sys/CarbonEmissionFactor/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 碳排放因子详情
 * @param {object} parameter
 */
export function getCarbonEmissionFactorById (parameter) {
  return request({
    url: `/sys/CarbonEmissionFactor/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除碳排放因子
 * @param {object} parameter
 */
export function deleteCarbonEmissionFactorById (parameter) {
  return request({
    url: `/sys/CarbonEmissionFactor/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存碳排放因子
 * @param {object} parameter
 */
export function saveCarbonEmissionFactorSite (parameter) {
  return request({
    url: `/sys/CarbonEmissionFactor/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改碳排放因子
 * @param {object} parameter
 */
export function updateCarbonEmissionFactorSite (parameter) {
  return request({
    url: `/sys/CarbonEmissionFactor/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询碳排放明细表列表
 * @param {object} parameter
 */
export function getCarbonEmissionManageList (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询碳排放明细表详情
 * @param {object} parameter
 */
export function getCarbonEmissionManageById (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除碳排放明细表
 * @param {object} parameter
 */
export function deleteCarbonEmissionManageById (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存碳排放明细表
 * @param {object} parameter
 */
export function saveCarbonEmissionManage (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改碳排放明细表
 * @param {object} parameter
 */
export function updateCarbonEmissionManage (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询月度碳排放明细表列表
 * @param {object} parameter
 */
export function getCarbonEmissionMonthList (parameter) {
  return request({
    url: `/sys/CarbonEmissionMonth/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【定时任务】月度碳排放量
 * @param {object} parameter
 */
export function getCarbonEmissionMonthTask (parameter) {
  return request({
    url: `/sys/CarbonEmissionManage/carbonEmissionMonthTask`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询未使用的【碳排放因子单位】数据
 * @param {object} parameter
 */
export function getCarbonUnitList (parameter) {
  return request({
    url: `/sys/CarbonEmissionUnit/getCarbonUnitList/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询所属工区列表
 * @param {object} parameter
 */
export function getCarbonEmissionWorkareaList (parameter) {
  return request({
    url: '/sys/CarbonEmissionWorkarea/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询所属工区详情
 * @param {object} parameter
 */
export function getCarbonEmissionWorkareaById (parameter) {
  return request({
    url: `/sys/CarbonEmissionWorkarea/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除所属工区
 * @param {object} parameter
 */
export function deleteCarbonEmissionWorkareaById (parameter) {
  return request({
    url: `/sys/CarbonEmissionWorkarea/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存所属工区
 * @param {object} parameter
 */
export function saveCarbonEmissionWorkarea (parameter) {
  return request({
    url: `/sys/CarbonEmissionWorkarea/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改所属工区
 * @param {object} parameter
 */
export function updateCarbonEmissionWorkarea (parameter) {
  return request({
    url: `/sys/CarbonEmissionWorkarea/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询组成部位列表
 * @param {object} parameter
 */
export function getCarbonEmissionPositonList (parameter) {
  return request({
    url: '/sys/CarbonEmissionPositon/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询组成部位详情
 * @param {object} parameter
 */
export function getCarbonEmissionPositonById (parameter) {
  return request({
    url: `/sys/CarbonEmissionPositon/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除组成部位
 * @param {object} parameter
 */
export function deleteCarbonEmissionPositonById (parameter) {
  return request({
    url: `/sys/CarbonEmissionPositon/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存组成部位
 * @param {object} parameter
 */
export function saveCarbonEmissionPositon (parameter) {
  return request({
    url: `/sys/CarbonEmissionPositon/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改组成部位
 * @param {object} parameter
 */
export function updateCarbonEmissionPositon (parameter) {
  return request({
    url: `/sys/CarbonEmissionPositon/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询分项类型列表
 * @param {object} parameter
 */
export function getCarbonEmissionItemizeList (parameter) {
  return request({
    url: '/sys/CarbonEmissionItemize/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询分项类型详情
 * @param {object} parameter
 */
export function getCarbonEmissionItemizeById (parameter) {
  return request({
    url: `/sys/CarbonEmissionItemize/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除分项类型
 * @param {object} parameter
 */
export function deleteCarbonEmissionItemizeById (parameter) {
  return request({
    url: `/sys/CarbonEmissionItemize/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存分项类型
 * @param {object} parameter
 */
export function saveCarbonEmissionItemize (parameter) {
  return request({
    url: `/sys/CarbonEmissionItemize/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改分项类型
 * @param {object} parameter
 */
export function updateCarbonEmissionItemize (parameter) {
  return request({
    url: `/sys/CarbonEmissionItemize/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 碳排放明细表导出
 * @param {object} parameter
 */
export function exportCarbonEmissionManageExcel (parameter) {
  return request({
    url: `/file/excel/carbonEmissionExportExcel`,
    method: 'post',
    data: parameter
  })
}

// #endregion

// #endregion

// #region --------------------------应力监测（兴义长江大桥数字孪生信息化平台）------------------------------

/**
 * 查询应力监测列表
 * @param {object} parameter
 */
export function getStressSensorDataList (parameter = {}) {
  return request({
    url: 'machineryMgt/iot/StressSensorData/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询应力监测详情
 * @param {object} parameter
 */
export function getStressSensorDataById (parameter = {}) {
  return request({
    url: `machineryMgt/iot/StressSensorData/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 删除应力监测数据
 * @param {object} parameter
 */
export function deleteStressSensorDataById (parameter = {}) {
  return request({
    url: `machineryMgt/iot/StressSensorData/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存应力监测
 * @param {object} parameter
 */
export function saveStressSensorData (parameter = {}) {
  return request({
    url: 'machineryMgt/iot/StressSensorData/',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改应力监测
 * @param {object} parameter
 */
export function updateStressSensorData (parameter = {}) {
  return request({
    url: 'machineryMgt/iot/StressSensorData/',
    method: 'put',
    data: parameter
  })
}

// #endregion
